import { useState, useEffect } from 'react';
import DOMPurify from 'dompurify';
import Modal from '@mui/material/Modal';
import TextField from '@mui/material/TextField';
import { IoClose as Close } from 'react-icons/io5';
import Autocomplete from '@mui/material/Autocomplete';
import FormControlLabel from '@mui/material/FormControlLabel';
import Radio from '@mui/material/Radio';
import RadioGroup from '@mui/material/RadioGroup';
import FormControl from '@mui/material/FormControl';
import BorderBlueButtonV2 from '@CommonRepresentationalDisplay/Buttons/BorderBlueButtonV2';
import BorderWhiteButtonV2 from '@CommonRepresentationalDisplay/Buttons/BorderWhiteButtonV2';
import { ReactComponent as Edit } from '@Assets/editIcon.svg';
import FieldPageService from '@Helpers/URLHelpers/FieldPageService';
import ErrorHandler from '@Root/ErrorHandler';
import { useCursor } from '@Root/CursorContext';
import '@Partials/_ComStyles.scss';
import './FieldPageView.scss';

export default function FieldPageView(props) {

    const { cursor, setCursor } = useCursor();
    const [formPageSequenceList] = useState(props?.formFieldPageIdList);
    const [editTitle, setEditTitle] = useState(false);
    const [nextButtonBehaviour, setNextButtonBehaviour] = useState({});
    const [nextButtonBehaviourAction, setNextButtonBehaviourAction] = useState('next');
    const [nextPageSelectList, setNextPageSelectList] = useState([])
    const [nextSelectValue, setNextSelectValue] = useState()

    const [formFieldList, setFormFieldList] = useState();
    const [nextConditionalField, setNextConditionalField] = useState({'id': 0, 'title': 'N/A'});
    const [fieldPageTitle, setFieldPageTitle] = useState(null);
    const [, setFieldPageFieldIdList] = useState([]);
    const [nextFieldOptionConditionList, setNextFieldOptionConditionList] = useState([]);

    const [, setPageBackground] = useState({});
    const [, setPageHeader] = useState({});
    const [, setTheme] = useState({});
    const [, setBackgroundStyle] = useState({});

    const [refresh, setRefresh] = useState(false);
    const errorHandler = new ErrorHandler();
    const fieldPageService = new FieldPageService();
    const className = 'fieldPageView';

    useEffect(() => {
        parseData();
    }, [props])

    const parseData = () => {
        if(!!props?.fieldPage?.details){
            let detailsObj = JSON.parse(props.fieldPage.details);
            setPageBackground(detailsObj?.pageBackground);
            setPageHeader(detailsObj?.pageHeader);
            setFieldPageTitle(detailsObj?.title ?? null);
            setTheme(detailsObj?.theme);
            setFieldPageFieldIdList(JSON.parse(props.fieldPage.fields));
            const pageBackgroundObjValue = props?.formDetails?.settings?.pageBackground;
            let formPageSequenceListObj = props?.formFieldPageIdList;
            if(pageBackgroundObjValue) {
                if(pageBackgroundObjValue.type === 'solid') {
                    setBackgroundStyle({
                        background: pageBackgroundObjValue.color
                    });
                } else if(pageBackgroundObjValue.type === 'image') {
                    setBackgroundStyle({
                        backgroundImage: 'url("' + pageBackgroundObjValue.imageURL + '")',
                        backgroundSize: 'cover'
                    });
                }
            }
            let nextPageSelectListObj = nextPageSelectList;
            for(var i = 0; i < formPageSequenceListObj?.length; i++) {
                if(i > props?.index) {
                    let pageObj = props?.formFieldPageList.find((formFieldPage) => formFieldPage?.id === formPageSequenceListObj[i]);
                    let detailsObj = JSON.parse(pageObj.details);
                    nextPageSelectListObj = [...nextPageSelectListObj, {
                        'id': (nextPageSelectListObj?.length),
                        'display': (detailsObj?.title ?? ('Page ' + (i + 1))),
                        'value' : pageObj?.id
                    }];
                }
            }
            nextPageSelectListObj = [...nextPageSelectListObj, {
                'id': (nextPageSelectListObj?.length),
                'display': 'Submit',
                'value' : 0
            }]
            setNextPageSelectList(nextPageSelectListObj);
            let formFieldListObj = [];
            let fieldPageFieldList = props?.fieldPage.fields;
            for(var i = 0; i < props?.formFieldList?.length; i++) {
                let fieldObj = props?.formFieldList[i];
                if((fieldObj?.type === 'multiChoice' || fieldObj?.type === 'condition') && fieldPageFieldList.indexOf(fieldObj?.id) > -1
                    && JSON.parse(fieldObj?.rules)?.find((rule) => rule?.type === 'required')?.value === true) {
                    formFieldListObj = [...formFieldListObj, fieldObj];
                }
            }
            if(formFieldListObj?.length != 0) {
                setFormFieldList(formFieldListObj);
            }
            let buttonBehaviour = detailsObj?.buttonBehaviour;
            if (!buttonBehaviour) {
                buttonBehaviour = {};
            }
            let nextObj = buttonBehaviour?.next;
            let nextButtonBehaviourObj = {};
            if(!nextObj) {
                if(props?.index == (props?.formFieldPageList?.length - 1)) {
                    nextButtonBehaviourObj = {
                        'action': 'submit',
                        'value': 0,
                        'display': 'Submit'
                    };
                    setNextButtonBehaviourAction('submit');
                } else {
                    nextButtonBehaviourObj = {
                        'action': 'next',
                        'value': props?.formFieldPageList[props?.index + 1]?.id,
                        'display': JSON.parse(props?.formFieldPageList.find((formFieldPage) => formFieldPage?.id === formPageSequenceListObj[props?.index + 1])?.details)?.title ?? ('Page ' + (props?.index + 1))
                    };
                    setNextButtonBehaviourAction('next');
                    setNextSelectValue({
                        'id': (props?.index + 1),
                        'display': (JSON.parse(props?.formFieldPageList.find((formFieldPage) => formFieldPage?.id === formPageSequenceListObj[props?.index + 1])?.details)?.title ?? ('Page ' + (props?.index + 1))),
                        'value' : props?.formFieldPageList[props?.index + 1]?.id
                    });
                }
                setNextButtonBehaviour(nextButtonBehaviourObj);
                if(formFieldListObj?.length != 0) {
                    setNextConditionalField(formFieldListObj[0]);
                    let optionsObj = JSON.parse(formFieldListObj[0]?.options);
                    let nextFieldOptionConditionListObj = nextFieldOptionConditionList;
                    for(var i = 0; i< optionsObj?.length; i++) {
                        nextFieldOptionConditionListObj = [...nextFieldOptionConditionListObj, {
                            'option': optionsObj[i],
                            'goto': nextPageSelectListObj?.find((nextPageSelectItem) => nextPageSelectItem?.value === nextButtonBehaviourObj?.value)
                        }]
                    }
                    setNextFieldOptionConditionList(nextFieldOptionConditionListObj);
                } else {
                    setNextConditionalField({
                        'title': 'N/A',
                        'id': 0
                    })
                }
            } else {
                nextButtonBehaviourObj = nextObj?.behaviour;
                if((nextButtonBehaviourObj.action === 'next' || nextButtonBehaviourObj.action === 'goto')) {
                    setNextSelectValue(nextObj?.nextPage);
                }
                if(nextButtonBehaviourObj.action === 'conditional') {
                    if(formFieldListObj?.length != 0) {
                        let nextConditionalFieldObj = formFieldListObj?.find((formField) => formField?.id === nextObj?.conditionalField);
                        if(!!nextConditionalFieldObj) {
                            setNextConditionalField(nextConditionalFieldObj);
                            setNextFieldOptionConditionList(nextObj?.value);
                        } else {
                            setNextConditionalField(formFieldListObj[0]);
                            let optionsObj = JSON.parse(formFieldListObj[0]?.options);
                            let nextFieldOptionConditionListObj = nextFieldOptionConditionList;
                            for(var i = 0; i< optionsObj?.length; i++) {
                                nextFieldOptionConditionListObj = [...nextFieldOptionConditionListObj, {
                                    'option': optionsObj[i],
                                    'goto': nextPageSelectListObj?.find((nextPageSelectItem) => nextPageSelectItem?.value === nextButtonBehaviourObj?.value)
                                }]
                            }
                            setNextFieldOptionConditionList(nextFieldOptionConditionListObj);
                        }
                    }
                }
                setNextButtonBehaviour(nextButtonBehaviourObj);
                setNextButtonBehaviourAction(nextButtonBehaviourObj?.action);
                setRefresh(!refresh);
            }
        }
    }

    const handleUpdate = async () => {
        setCursor('wait');
        try {
            let fieldPageObj = props?.fieldPage;
            let detailsObj = JSON.parse(fieldPageObj?.details);
            let buttonBehaviour = {
                'next': {
                    'behaviour': nextButtonBehaviour,
                    'nextPage': ((nextButtonBehaviour.action === 'next' || nextButtonBehaviour.action === 'goto') ? nextSelectValue : {}),
                    'conditionalField': (nextButtonBehaviour.action === 'conditional' ? nextConditionalField?.id : {}),
                    'value': (nextButtonBehaviour.action === 'conditional' ? nextFieldOptionConditionList : {})
                }
            }
            detailsObj.buttonBehaviour = buttonBehaviour;
            fieldPageObj.details = JSON.stringify(detailsObj);
            fieldPageObj = await fieldPageService.updateFieldPage(fieldPageObj);
            props?.reloadFieldPageListData(props.fieldPage?.tableId);
        } catch(err) {
            errorHandler.handleError(err);
        }
        setCursor('auto');
    }

    const handleTitleSubmit = async () => {
        setCursor('wait');
        try {
            let fieldPageObj = props?.fieldPage;
            let detailsObj = JSON.parse(fieldPageObj.details);
            detailsObj.title = fieldPageTitle;
            fieldPageObj.details = JSON.stringify(detailsObj);
            fieldPageObj = await fieldPageService.updateFieldPage(fieldPageObj);
            props?.reloadFieldPageListData(props.fieldPage?.tableId);
        } catch(err) {
            errorHandler.handleError(err);
        }
        setCursor('auto');
    }

    const handleTitleChange = (e) => {
        let sanitizedTitle = DOMPurify.sanitize(e.target.value);
        setFieldPageTitle(sanitizedTitle);
    }

    const editTitleOnKeyPress = (e) => {
        if(e.keyCode === 13) {
            toggleEditTitle()
        }
    }

    const toggleEditTitle = () => {
        if(editTitle) {
            handleTitleSubmit();
        }
        setEditTitle(!editTitle);
    }

    const handleNextButtonGotoSelect = async(e, value) => {
        setNextSelectValue(value);
    }

    const handleNextButtonBehaviourChange = (e) => {
        let nextButtonBehaviourObj = nextButtonBehaviour;
        nextButtonBehaviourObj.action = e.target.value;
        setNextButtonBehaviour(nextButtonBehaviourObj)
        setNextButtonBehaviourAction(e.target.value);
    }

    const handleNextConditionalFieldChange = (e, value) => {
        setNextConditionalField(value);
        let optionsObj = JSON.parse(value?.options);
        let nextFieldOptionConditionListObj = [];
        for(var i = 0; i< optionsObj?.length; i++) {
            nextFieldOptionConditionListObj = [...nextFieldOptionConditionListObj, {'option': optionsObj[i], 'goto': nextButtonBehaviour}]
        }
        setNextFieldOptionConditionList(nextFieldOptionConditionListObj);
    }

    const handleFieldOptionNextPageChange = (e, value, index) => {
        let nextFieldOptionConditionListObj = nextFieldOptionConditionList;
        nextFieldOptionConditionListObj[index]['goto'] = value;
        setNextFieldOptionConditionList(nextFieldOptionConditionListObj);
        setRefresh(!refresh);
    }

    return (
        <Modal
            open={props.open}
            onClose={props.closePopup}
            className={className}
            style={{ cursor: cursor }}
            aria-labelledby='modal-field-view'>
            <div className={className + '__inner'}>

                {/* ── Sticky title bar ── */}
                <div className={className + '__inner__titleBar'}>
                    <div className={className + '__inner__titleBar__left'}>
                        <span className={className + '__inner__titleBar__badge'}>Pg {props?.index + 1}</span>
                        <span className={className + '__inner__titleBar__title'}>
                            {fieldPageTitle || 'Untitled Page'}
                        </span>
                    </div>
                    <Close className={className + '__inner__titleBar__close close-button'} onClick={props.closePopup} />
                </div>

                {/* ── Scrollable body ── */}
                <div className={className + '__inner__body'}>

                    {/* Page title card */}
                    <div className={className + '__inner__body__card'}>
                        <div className={className + '__inner__body__card__header'}>
                            <span className={className + '__inner__body__card__header__label'}>Page Title</span>
                            <button
                                type='button'
                                className={className + '__inner__body__card__header__editBtn'}
                                onClick={toggleEditTitle}
                                aria-label='Edit page title'>
                                <Edit className={className + '__inner__body__card__header__editIcon'} />
                                {editTitle ? 'Done' : 'Edit'}
                            </button>
                        </div>
                        {editTitle ? (
                            <TextField
                                placeholder='Enter title ...'
                                fullWidth
                                size='small'
                                helperText='Press Enter to save'
                                disabled={cursor === 'wait'}
                                onChange={handleTitleChange}
                                onKeyDown={editTitleOnKeyPress}
                                inputProps={{ maxLength: 200 }}
                                value={fieldPageTitle ?? ''}
                                variant='outlined'
                                autoFocus
                            />
                        ) : (
                            <div
                                className={className + '__inner__body__card__titleDisplay'}
                                onClick={toggleEditTitle}
                                role='button'
                                aria-label='Click to edit title'>
                                {fieldPageTitle || <span className='grey-text'>No title set — click to add</span>}
                            </div>
                        )}
                    </div>

                    {/* Navigation / button behaviour card */}
                    <div className={className + '__inner__body__card'}>
                        <div className={className + '__inner__body__card__header'}>
                            <span className={className + '__inner__body__card__header__label'}>Navigation</span>
                        </div>

                        {/* Back */}
                        <div className={className + '__inner__body__card__section'}>
                            <div className={className + '__inner__body__card__section__title'}>Back Button</div>
                            <div className={className + '__inner__body__card__section__desc grey-text'}>
                                Automatically returns to the previous page the user navigated from.
                            </div>
                        </div>

                        {/* Next */}
                        <div className={className + '__inner__body__card__section'}>
                            <div className={className + '__inner__body__card__section__title'}>Next Button Behaviour</div>
                            <div className={className + '__inner__body__card__section__desc grey-text'}>
                                Define what happens when the user taps Next.
                            </div>
                            <FormControl className={className + '__inner__body__card__section__control'}>
                                <RadioGroup
                                    value={nextButtonBehaviourAction}
                                    onChange={handleNextButtonBehaviourChange}>
                                    <FormControlLabel
                                        value='submit'
                                        control={<Radio size='small' />}
                                        label='Submit form' />
                                    <FormControlLabel
                                        value='next'
                                        disabled={props?.index === props?.formFieldPageList?.length - 1}
                                        control={<Radio size='small' />}
                                        label={
                                            <>
                                                Go to next page
                                                {props?.index !== props?.formFieldPageList?.length - 1 && (
                                                    <span className={className + '__inner__body__card__section__nextLabel'}>
                                                        &nbsp;→&nbsp;
                                                        <b>{
                                                            props?.formFieldPageList?.find((fp) => fp?.id === formPageSequenceList?.[props?.index + 1])
                                                                ? (JSON.parse(props?.formFieldPageList?.find((fp) => fp?.id === formPageSequenceList?.[props?.index + 1])?.details)?.title ?? ('Page ' + (props?.index + 2)))
                                                                : 'N/A'
                                                        }</b>
                                                    </span>
                                                )}
                                            </>
                                        }
                                    />
                                    <FormControlLabel
                                        value='goto'
                                        disabled={props?.index === props?.formFieldPageList?.length - 1}
                                        control={<Radio size='small' />}
                                        label={
                                            <div className={className + '__inner__body__card__section__gotoRow'}>
                                                Go to specific page
                                                <Autocomplete
                                                    options={nextPageSelectList}
                                                    disabled={cursor === 'wait' || nextButtonBehaviourAction !== 'goto'}
                                                    value={nextSelectValue ?? null}
                                                    className={className + '__inner__body__card__section__select'}
                                                    getOptionLabel={(option) => option.display}
                                                    isOptionEqualToValue={(option, value) => option.value === value.value}
                                                    onChange={handleNextButtonGotoSelect}
                                                    size='small'
                                                    renderInput={(params) => (
                                                        <TextField {...params} placeholder='Select page' variant='outlined' />
                                                    )}
                                                />
                                            </div>
                                        }
                                    />
                                    <FormControlLabel
                                        value='conditional'
                                        disabled={props?.index === props?.formFieldPageList?.length - 1 || !formFieldList || formFieldList?.length === 0}
                                        control={<Radio size='small' />}
                                        label='Conditional (based on a field answer)' />
                                </RadioGroup>
                            </FormControl>

                            {/* Conditional options */}
                            {nextButtonBehaviourAction === 'conditional' && (
                                <div className={className + '__inner__body__card__conditional'}>
                                    <div className={className + '__inner__body__card__conditional__row'}>
                                        <span className={className + '__inner__body__card__conditional__row__label'}>Conditional Field</span>
                                        <Autocomplete
                                            options={formFieldList ?? []}
                                            disabled={cursor === 'wait'}
                                            value={nextConditionalField ?? null}
                                            className={className + '__inner__body__card__section__select'}
                                            getOptionLabel={(option) => option.title}
                                            isOptionEqualToValue={(option, value) => option.id === value.id}
                                            onChange={handleNextConditionalFieldChange}
                                            size='small'
                                            renderInput={(params) => (
                                                <TextField {...params} placeholder='Select field' variant='outlined' />
                                            )}
                                        />
                                    </div>
                                    {nextFieldOptionConditionList?.length > 0 && (
                                        <div className={className + '__inner__body__card__conditional__options'}>
                                            <div className={className + '__inner__body__card__conditional__options__header'}>
                                                <span>Option</span>
                                                <span>Goes to</span>
                                            </div>
                                            {nextFieldOptionConditionList.map((item, index) => (
                                                <div key={index} className={className + '__inner__body__card__conditional__options__row'}>
                                                    <div className={className + '__inner__body__card__conditional__options__row__left'}>
                                                        <span
                                                            className={className + '__inner__body__card__conditional__options__row__dot'}
                                                            style={{ backgroundColor: item?.option?.color }}
                                                        />
                                                        <span>{item?.option?.title}</span>
                                                    </div>
                                                    <Autocomplete
                                                        options={nextPageSelectList}
                                                        disabled={cursor === 'wait'}
                                                        value={item?.goto ?? null}
                                                        className={className + '__inner__body__card__section__select'}
                                                        getOptionLabel={(option) => option.display}
                                                        isOptionEqualToValue={(option, value) => option.value === value.value}
                                                        onChange={(e, value) => handleFieldOptionNextPageChange(e, value, index)}
                                                        size='small'
                                                        renderInput={(params) => (
                                                            <TextField {...params} placeholder='Select page' variant='outlined' />
                                                        )}
                                                    />
                                                </div>
                                            ))}
                                        </div>
                                    )}
                                </div>
                            )}
                        </div>
                    </div>
                </div>

                {/* ── Sticky footer ── */}
                <div className={className + '__inner__footer'}>
                    <BorderWhiteButtonV2
                        text='Cancel'
                        onClick={props.closePopup}
                        disabled={cursor === 'wait'}
                    />
                    <BorderBlueButtonV2
                        text='Update'
                        onClick={handleUpdate}
                        disabled={cursor === 'wait'}
                    />
                </div>
            </div>
        </Modal>
    );
}
